<template>
	<div class="indexAll"  v-if="flag">
		<div class="container">
			<div  style=" margin-top: 80px;">
				<p v-html="aboutList[0].hContent"></p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getContentListId
	} from "@/api/index";

	export default {
		name: 'About',
		created() {
			this.getContentListId(this.$route.query.id)
		},
		data() {
			return {
				aboutList: [],
				flag: false,
			}
		},
		methods: {
			getContentListId(id) {
				getContentListId(id).then(res => {
					if (res.data.code == 200) {
						this.flag = true
						this.aboutList = res.data.rows;
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
